// extracted by mini-css-extract-plugin
export default {"imgbox":"SubBanner_imgbox__1OOwk","center":"SubBanner_center__rXDco","head":"SubBanner_head__-mINH","subHead":"SubBanner_subHead__cHgD4"};